import * as React from "react";
import bodiZahiral from "../../assets/bodi_zahiral.png";

const headingStyle = { fontFamily: '"Sustainability", sans-serif' };
const bodyStyle = { fontFamily: "Sustainability, sans-serif" };

function AboutUs() {
  return (
    <section className="w-full bg-[#fff] mt-14 md:mt-20 pb-16 md:pb-24">
      <div className="max-w-[1400px] min-[1920px]:max-w-[1880px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 mt-6 md:mt-10 lg:mt-14 gap-y-8 md:gap-y-12">
          <div className="bg-[#fff] px-4 md:px-10 py-8 md:py-14 lg:py-16 flex items-center">
            <div className="max-w-[850px] mx-auto">
              <h2 className="text-[22px] sm:text-[26px] md:text-[32px] lg:text-[42px] text-[#1f1a16] mb-6 md:mb-8 text-center md:text-left leading-tight" style={headingStyle}>
                Community
              </h2>
              <p className="text-[13px] sm:text-[12px] md:text-[13px] lg:text-[14px] min-[1920px]:text-[14px] leading-[1.75] md:leading-[1.85] text-[#5f574c] font-light text-left" style={bodyStyle}>
                Lorem ipsum dolor sit amet consectetur. Ut fermentum dolor nec risus ut ipsum magna. Odio non dictumst
                curabitur neque fermentum praesent leo sit venenatis. Consectetur et mauris integer at ullamcorper
                suspendisse ullamcorper euismod dui. Maecenas mattis scelerisque eget nibh non laoreet euismod id sed.
                Iaculis sit viverra at enim. Dui fringilla ac augue turpis cursus duis. Sed orci quis tortor imperdiet
                dignissim. Sodales ipsum ipsum rhoncus turpis vivamus diam faucibus interdum. Nunc quam in vitae risus
                neque diam massa egestas eu. Dolor lectus porttitor diam mi magna. Eu quam sed neque feugiat. Faucibus
                eleifend suspendisse porta etiam porttitor mauris. Cras.
              </p>
            </div>
          </div>
          <div className="w-full flex justify-center items-center py-4">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/b5dcf6fe1b98f09c8c92efddefd21a3f4b63b89aaf6d85874096b9de34aa9917?apiKey=9804d3a088fa478e8672485264720a14&"
              alt="About Bodios"
              className="w-full max-w-[460px] md:max-w-[500px] aspect-[64/43] object-cover object-top min-[1920px]:w-[910px] min-[1920px]:h-[660px] min-[1920px]:max-w-none min-[1920px]:aspect-auto"
            />
          </div>
          <div className="w-full flex justify-center items-center py-4">
            <img
              src={bodiZahiral}
              alt="People sitting under a tree"
              className="w-full max-w-[460px] md:max-w-[500px] aspect-[64/43] object-cover object-top min-[1920px]:w-[910px] min-[1920px]:h-[660px] min-[1920px]:max-w-none min-[1920px]:aspect-auto"
            />
          </div>

          <div className="bg-[#fff] px-4 md:px-10 py-8 md:py-14 lg:py-16 flex items-center">
            <div className="max-w-[850px] mx-auto">
              <h3 className="text-[22px] sm:text-[26px] md:text-[32px] lg:text-[42px] text-[#1f1a16] mb-6 md:mb-8 text-center md:text-left leading-tight" style={headingStyle}>
               Our founder
              </h3>
              <p className="text-[13px] sm:text-[12px] md:text-[13px] lg:text-[14px] min-[1920px]:text-[14px] leading-[1.75] md:leading-[1.85] text-[#5f574c] font-light text-left" style={bodyStyle}>
                Inspired by the extraordinary qualities of yak down—its inherent warmth, luxury, and softness—J. Ulziibodijav founded BODIOS to bring this unique material to life. With a passion for innovation, he devoted himself to refining yak down’s natural properties, crafting designs that honor both quality and nature’s elegance. By blending tradition with modern techniques, BODIOS has created a collection of yak down garments that are cherished both locally and internationally by those who appreciate unparalleled comfort, quality, and sustainability.
              </p>
            </div>
          </div>

          <div className="bg-[#fff] px-4 md:px-10 py-8 md:py-14 lg:py-16 flex items-center">
            <div className="max-w-[850px] mx-auto">
              <h3 className="text-[22px] sm:text-[26px] md:text-[32px] lg:text-[42px] text-[#1f1a16] mb-6 md:mb-8 text-center md:text-left leading-tight" style={headingStyle}>
                Philosophy
              </h3>
              <p className="text-[13px] sm:text-[12px] md:text-[13px] lg:text-[14px] min-[1920px]:text-[14px] leading-[1.75] md:leading-[1.85] text-[#5f574c] font-light text-left" style={bodyStyle}>
                BODIOS crafts products from yak down, offering exceptional warmth, comfort, and environmental sustainability. Committed to ethical business principles that support herders, we strive to bring people closer to nature.
              </p>
            </div>
          </div>

          <div className="w-full flex justify-center items-center py-4">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/298048f44cb87f8a912c8acdf1919739c268f331054c18a3a9d5fa2ee36ac044?apiKey=9804d3a088fa478e8672485264720a14&"
              alt="Brown sheep portrait"
              className="w-full max-w-[460px] md:max-w-[500px] aspect-[64/43] object-cover min-[1920px]:w-[910px] min-[1920px]:h-[660px] min-[1920px]:max-w-none min-[1920px]:aspect-auto"
            />
          </div>

        </div>
      </div>
    </section>
  );
}

export default AboutUs;